import React, { useState } from 'react'
import { COLORS } from 'theme'

import { CardRow } from '../../../TPODashboard/Components/StyledComponent'
import InfoCardsUpdateClick from '../../../../components/InfoCardsUpdateClick'

const DashBoardCard = ({
  handleCardClick,
  cardData,
  selectedCard,
  setSelectedCard,
}) => {
  return (
    <div>
      <CardRow spaceBetween>
        {cardData.map(card => (
          <InfoCardsUpdateClick
            key={card.key}
            width={'33em'}
            icon={card.icon}
            IconText={card.IconText}
            text={card.text}
            value={card.value}
            background={card.backgroundColor || '#FFFFFF'}
            borderColor={
              selectedCard === card.key && card.key === 2
                ? 'red'
                : selectedCard === card.key
                ? '#3249D7'
                : '#BFBFBF'
            }
            valueColor={
              selectedCard === card.key && card.key === 2
                ? 'red'
                : selectedCard === card.key
                ? '#3249D7'
                : COLORS.GREY_T_20
            }
            isSelected={selectedCard === card.key}
            onClick={() => handleCardClick(card.key)}
          />
        ))}
      </CardRow>
    </div>
  )
}

export default DashBoardCard
